module.exports = __webpack_public_path__ + "static/media/objects2_12.81c15bcc.svg";